module.exports = __webpack_public_path__ + "img/briefcase-arrow-right.ceb4df3c.svg";